// extracted by mini-css-extract-plugin
export default {"sigPad":"styles_sigPad__FW+8b"};